import { useEffect, useState } from "react";
import { useLocation, useParams } from "wouter";
import { trpc } from "@/lib/trpc";
import { Loader2, CheckCircle, XCircle } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

export default function MagicLink() {
  const { token } = useParams<{ token: string }>();
  const [, navigate] = useLocation();
  const { login: authLogin } = useAuth();
  const [status, setStatus] = useState<"loading" | "success" | "error">("loading");
  const [errorMsg, setErrorMsg] = useState("");

  const loginMutation = trpc.clientAuth.verifyMagicLink.useMutation({
    onSuccess: (data) => {
      // mustChangePassword: true porque essa rota sempre força reset
      authLogin({
        token:      data.token,
        userId:     data.userId,
        name:       data.name ?? "",
        email:      data.email,
        role:       (data.role ?? "viewer") as "admin" | "editor" | "viewer",
        clientId:   data.clientId ?? null,
        isRazAdmin: data.isRazAdmin ?? false,
        mustChangePassword: true,
      });
      setStatus("success");
      // Always redirect to change password after magic link
      setTimeout(() => navigate("/redefinir-senha"), 1500);
    },
    onError: (err) => {
      setStatus("error");
      setErrorMsg(err.message);
    },
  });

  useEffect(() => {
    if (token) {
      loginMutation.mutate({ token });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--solar-bg)] p-4">
      <div className="text-center max-w-sm w-full rounded-xl border border-[var(--solar-line)] bg-white shadow-[var(--elev-2)] p-10">
        {status === "loading" && (
          <>
            <Loader2 className="h-12 w-12 animate-spin text-[var(--brand)] mx-auto mb-4" />
            <h2 className="text-[var(--solar-ink)] text-xl font-semibold">Verificando link de acesso...</h2>
            <p className="text-[var(--solar-mute)] mt-2">Aguarde um momento</p>
          </>
        )}
        {status === "success" && (
          <>
            <CheckCircle className="h-12 w-12 text-[var(--brand)] mx-auto mb-4" />
            <h2 className="text-[var(--solar-ink)] text-xl font-semibold">Acesso confirmado</h2>
            <p className="text-[var(--ink-2)] mt-2">Redirecionando para redefinição de senha...</p>
          </>
        )}
        {status === "error" && (
          <>
            <XCircle className="h-12 w-12 text-[var(--destructive)] mx-auto mb-4" />
            <h2 className="text-[var(--solar-ink)] text-xl font-semibold">Link inválido ou expirado</h2>
            <p className="text-[var(--ink-2)] mt-2">{errorMsg}</p>
            <button
              onClick={() => navigate("/login")}
              className="mt-4 text-[var(--brand)] hover:underline text-sm"
            >
              Voltar ao login
            </button>
          </>
        )}
      </div>
    </div>
  );
}
